import { createFileRoute } from '@tanstack/react-router';
import { AccessRolesPage, RequirePermission } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/perfis')({
  component: () => (
    <RequirePermission anyOf={['usuarios.ver', 'perfis.editar']}>
      <AccessRolesPage />
    </RequirePermission>
  ),
});
